import type { CartDiscountDto } from '@bondsports/types';
import * as React from 'react';
import { getDiscountColor, showRemoveDiscountButton } from '../../util';
import type { CartItemProps } from '../types';
import { Close } from '@components/atoms';
import { Button, Percentage, Price, Tags } from '@components/molecules';

type CartItemDiscountsProps = Pick<CartItemProps, 'item' | 'onRemoveDiscount' | 'isLoading' | 'currency'>;

type DiscountTagRightIcon = Pick<CartItemProps, 'onRemoveDiscount' | 'isLoading' | 'currency'> & {
	discount: CartDiscountDto;
};

const parseDiscountAmount = (amount: string) => {
	return `(${amount})`;
};

export const CartItemDiscounts = ({ item, onRemoveDiscount, isLoading, currency }: CartItemDiscountsProps) => {
	return (
		<div className="row-start-3 flex flex-row items-center justify-between gap-1" data-testid="cart-item-discounts">
			<Tags
				items={item.discounts!.map(discount => {
					return {
						color: getDiscountColor(discount.discountOn),
						children: discount.reason?.reason,
						rightIcon: (
							<DiscountTagRightIcon
								discount={discount}
								onRemoveDiscount={onRemoveDiscount}
								isLoading={isLoading}
								currency={currency}
							/>
						),
					};
				})}
				truncate
			/>
			<Price strikethrough size="sm" currency={currency} price={item.subtotal} />
		</div>
	);
};

const DiscountTagRightIcon = ({ discount, onRemoveDiscount, isLoading, currency }: DiscountTagRightIcon) => {
	const { percentage, discountAmount } = discount;
	return (
		<div className="flex flex-row items-center gap-1">
			{percentage ? (
				<Percentage percentage={percentage} size="xs" asChild negative parse={parseDiscountAmount} />
			) : (
				<Price price={discountAmount!} currency={currency} size="xs" asChild parse={parseDiscountAmount} />
			)}
			{showRemoveDiscountButton(discount.discountOn) && (
				<Button
					iconButton
					onClick={() => onRemoveDiscount?.(discount)}
					size="xs"
					disabled={isLoading}
					aria-label="Remove discount"
					data-testid="remove-single-discount"
					variant={null}
				>
					<Close />
				</Button>
			)}
		</div>
	);
};
